module.exports = __webpack_public_path__ + "static/img/YS-content.b129462.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/YS-content.jpg
// module id = 3PY6
// module chunks = 1